import React, { createContext, useReducer, useState } from "react";
import { authReducer } from "./AuthReducer";
import config from "../api/config";
import jwt_decode from "jwt-decode";
import { postSignIn, postSignUp, getLoginStatus, getPasswordRecoveryToken, postSingUpSendCode, postSingUpVerify, postVerifyPasswordRecovery } from "../api/auth";
import { getFeatures } from "../api/feature";
import { stringify } from "postcss";
import Swal from "sweetalert2";
import { postRefreshToken } from "../api/refreshToken";

const authInitialState = {
  status: "checking",
  token: null,
  tokenDecoded: null,
  refreshToken: null,
  navigation: {
    flux: "",
    actualScreen: "",
    previousScreen: "",
    previousState: null
  },
  kycAlert: {
    enabled: false,
    type: ""
  },
  user: null,
  alert: {
    title: "",
    message: "",
    type: "",
    enabled: false,
    okButtonTitle: "Entendido",
    okButtonclassName: null,
    continueAction: () => { }
  },
  errorMessage: "",
  permissions: [],
  cart: [],
  contacts: [],
  filtredContacts: [],
  profilePicture: "https://dev-app.tufiado.com/user/resources/profile.png",
  createCardFlux:{}
  
};

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, authInitialState);
  const [pathname, setPathname] = useState(0);
  const [previousScreenDefinite, setPreviousScreenDefinite] = useState(null);
  const [tokenn, setTokenn] = useState(null);
  const [documentProcess, SetDocumentProcess] = useState(false);
  const [notificationsSocket, setNotificationsSocket] = useState(null);
  const [totalPending, setTotalPending] = useState(0);

  const checkToken = async () => {
    const _token = localStorage.getItem('token');

    let tokenDecoded = jwt_decode(_token);
    let countDownDate = tokenDecoded?.exp;
    let seconds = Math.round(countDownDate - new Date() / 1000)

    if (seconds <= 180) {
      try {
        const { data } = await postRefreshToken();
        localStorage.setItem("token", data.data.accessToken);
        setTokenn(data.data.accessToken)
        return true
      } catch (error) {
        return false;
      }
    }
  };

  const resetContext = async () => {
    dispatch({
      type: "reset"
    });
  }


  const refreshToken = async () => {
    try {
      const { data } = await postRefreshToken();
      localStorage.setItem("token", data.data.accessToken);
      setTokenn(data.data.accessToken)
      return true
    } catch (error) {
      return false;
    }
  }


  const signUp = async ({ name, phoneNumber, countryId, birthDate, password, referralCode, code }) => {
    try {
      checkToken()
      setLoading(true);
      const { data } = await postSignUp({ name, phoneNumber, countryId, birthDate, password, referralCode, code })
      //console.log(data.code)

      await localStorage.setItem('registerToken', data.data.accessToken)
      let token = await localStorage.getItem('registerToken');
      const tokenDecode = jwt_decode(token);
      dispatch({
        type: "signUp",
        payload: {
          token: data.token,
          tokenDecoded: tokenDecode,
        },
      });
      setLoading(false);
      return true;
    } catch (e) {
      setLoading(false);
      if (e.code == "ERR_NETWORK") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      } else {
        if (e.response.data.code == "USER_ALREADY_EXISTS") {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: "El teléfono ya se encuentra registrado",
            icon: 'warning',
            iconColor: "#fd6e0d",
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            confirmButtonText: 'Entendido'
          })
        } else {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: "Su solicitud no puede ser procesada",
            icon: 'warning',
            iconColor: "#fd6e0d",
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            confirmButtonText: 'Entendido'
          })
        }
      }
      return false;
    }
  }


  const setProfilePicture = async (payload) => {
    dispatch({
      type: "profilePicture",
      payload: payload
    });
  }


  const dispatchCreateCardFlux = ({
    pan = "",
    expirationMonth="",
    expirationYear="",
    name="",
    lastName=""
  })=>{

    dispatch({
      type: 'createCardFlux',
      payload: {pan,expirationMonth,expirationYear,name,lastName}
    })
    
  }

  const signIn = async ({ username, password }) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postSignIn({ username, password });
      setLoading(false);
      localStorage.setItem("token", data.data.accessToken);
      setTokenn(data.data.accessToken)
      localStorage.setItem("refreshToken", data.data.refreshToken);



      let tokenDecoded = jwt_decode(data.data.accessToken);
      await localStorage.setItem('tokenDecoded', JSON.stringify(tokenDecoded))
      dispatch({
        type: "signIn",
        payload: {
          token: data.data.accessToken,
          tokenDecoded: tokenDecoded,
          refreshToken: data.data.refreshToken,
        },
      });

      setPermissions(['REQUEST_FIADO', 'SPEND_FIADO', 'PAY_FIADO', 'FIADO_SUBSCRIPTIONS'])
      return true

    } catch (error) {

      setError(error.response.data.msg || "Error al procesar la solicitud")
      setLoading(false);
      return false;
    }
  };

  const loginStatus = async (phoneNumber) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getLoginStatus(phoneNumber);
      setLoading(false);
      return { code: data.code, status: data.data.status };
    } catch (error) {
      setLoading(false);
      if (error.response.data == undefined) {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          confirmButtonText: 'Entendido'
        })
      } else {
        return { code: null, status: error.response.data.code };
      }
    }
  };

  const PasswordRecoveryToken = async (phoneNumber) => {
    checkToken()
    setLoading(true);

    try {
      const data = await getPasswordRecoveryToken(phoneNumber);
      await localStorage.setItem('registerToken', data.data.data.accessToken)
      setLoading(false);
      return { code: data.data.code, status: data.data.data.status };
    } catch (e) {
      setLoading(false);
      if (e.code == "ERR_NETWORK") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
        return false;
      } else {
        return { code: e.code, status: e.response.data.code };
      }
    }
  };

  const SingUpSendCode = async () => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postSingUpSendCode({
        "deliveryChannel": "SMS"
      });
      //console.log(data);

      setLoading(false);
      return { code: data.code, status: data.code, data: data.data };
    } catch (error) {
      //console.log(error)
      setLoading(false);
      return { code: null, status: error.response.data.msg };
    }
  };

  const SingUpVerify = async (d) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postSingUpVerify(d);
      setLoading(false);
      return { code: data.code, status: data.code, data: data.data };
    } catch (e) {
      setLoading(false);
      if (e.code == "ERR_NETWORK") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
        return false;
      } else {
        return { code: e.code, status: e.response.data.code };
      }
    }
  };

  const VerifyPasswordRecovery = async (d) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postVerifyPasswordRecovery(d);
      setLoading(false);
      return { code: data.code, status: data.code, data: data.data };
    } catch (e) {
      setLoading(false);
      //console.log(e)
      if (e.code == "ERR_NETWORK" || e.response.data.code == "INTERNAL_ERROR") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
        return false;
      }
      else {
        return { code: e.code, status: e.response.data.code };
      }
    }
  };

  const setToken = (payload) => {
    dispatch({
      type: "signUp",
      payload: {
        token: payload.token,
        tokenDecoded: payload.tokenDecoded
      },
    });
  }

  const removeError = () => {
    dispatch({ type: 'removeError' })
  }

  const logOut = async () => {
    await localStorage.removeItem('token');
    dispatch({ type: 'logout' })
  }

  const setError = (error) => {
    dispatch({
      type: 'setError',
      payload: error
    })
  }

  const setAlert = (title = "", message = "", type = "ALERT", enabled = true, continueAction, okButtonTitle = "Entendido", okButtonclassName = "") => {
    dispatch({
      type: 'setAlert',
      payload: { title, message, type, enabled, continueAction, okButtonTitle, okButtonclassName }
    })
  }

  const removeAlert = () => {
    dispatch({
      type: 'setAlert',
      payload: { title: "", message: "", type: "", enabled: "", continueAction: () => { } }
    })
  }

  const setLoading = (bool) => {
    dispatch({
      type: 'setLoading',
      payload: bool
    })
  }

  const setRefreshToken = (payload) => {
    dispatch({
      type: 'setRefreshToken',
      payload: {
        token: payload.token,
        tokenDecoded: payload.tokenDecoded,
        refreshToken: payload.refreshToken,
      },
    })
  }

  const setPermissions = async (payload) => {
    checkToken()
    setLoading(true);

    try {
      let data = await getFeatures(payload);
      ////console.log('respuesta de suscripcion');
      ////console.log(data);
      data = data.data.data;
      dispatch({
        type: "permissions",
        payload: data
      });
      setLoading(false);

    } catch (error) {
      setLoading(false);
      throw error;
    }

  }

  const setCart = async (payload) => {
    setLoading(true);
    dispatch({
      type: "cart",
      payload: payload
    });
    setLoading(false);
  }

  const setContacts = async (payload) => {
    dispatch({
      type: "contacts",
      payload: payload
    });
  }


  const setFiltredContacts = async (payload) => {
    dispatch({
      type: "filtredContacts",
      payload: payload
    });
  }

  const setNavigation = async ({
    flux = "",
    actualScreen = "",
    previousScreen = "",
    previousState = null
  }) => {
    dispatch({
      type: "navigation",
      payload: { flux, actualScreen, previousScreen, previousState }
    });
  }

  const setKycAlert = async ({
    type = "PENDING",
    enabled = true,
  }) => {
    dispatch({
      type: "kycAlert",
      payload: { type, enabled }
    });
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        signIn,
        signUp,
        loginStatus,
        PasswordRecoveryToken,
        SingUpSendCode,
        SingUpVerify,
        removeError,
        setLoading,
        setToken,
        tokenn, setTokenn,
        setError,
        setAlert,
        removeAlert,
        logOut,
        setRefreshToken,
        setPermissions,
        setCart,
        setContacts,
        setFiltredContacts,
        setProfilePicture,
        setNavigation,
        VerifyPasswordRecovery,
        setKycAlert,
        checkToken,
        refreshToken,
        resetContext,
        dispatchCreateCardFlux,
        notificationsSocket, setNotificationsSocket,
        pathname, setPathname,
        previousScreenDefinite, setPreviousScreenDefinite,
        documentProcess, SetDocumentProcess,
        totalPending, setTotalPending
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
